import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { AddMenuSubcategory$Params } from 'src/api/generated/fn/menu-v-2/add-menu-subcategory';
import { UpdateMenuSubcategory$Params } from 'src/api/generated/fn/menu-v-2/update-menu-subcategory';
import { MenuCategoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/MenuCategories/menu-category-dto';
import { AddMenuSubcategoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/MenuSubcategories/add-menu-subcategory-dto';
import { MenuSubcategoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/MenuSubcategories/menu-subcategory-dto';
import { UpdateMenuSubcategoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/MenuSubcategories/update-menu-subcategory-dto';
import { MenuV2Service } from 'src/api/generated/services';

@Component({
  selector: 'app-add-or-edit-menu-subcategory',
  templateUrl: './add-or-edit-menu-subcategory.component.html',
  styleUrls: ['./add-or-edit-menu-subcategory.component.scss']
})
export class AddOrEditMenuSubcategoryComponent implements OnInit {
  public unsubscribe: Subject<void> = new Subject<void>();
  public menuCategory: MenuCategoryDto = {} as MenuCategoryDto;
  public menuSubcategory: MenuSubcategoryDto = {} as MenuSubcategoryDto;
  public editFlag: boolean = false;

  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private menuV2Service: MenuV2Service
  ) {
    
    if (this.config.data != undefined && this.config.data.category) {
      this.menuCategory = this.config.data.category;
    }
    if (this.config.data != undefined && this.config.data.subcategory) {
      this.menuSubcategory = this.config.data.subcategory;
      this.editFlag = true;
    }
  }

  ngOnInit(): void {
  }

  addSubcategory(f: NgForm) {
    if(f.valid){
      var params: AddMenuSubcategory$Params = {} as AddMenuSubcategory$Params;
      if(this.menuCategory.id){
        params.menuCategoryId = this.menuCategory.id;
      }
      const addMenuSubcategory: AddMenuSubcategoryDto = { menuCategoryId: this.menuCategory.id, name: this.menuSubcategory.name };
      params.body = addMenuSubcategory;
      this.menuV2Service.addMenuSubcategory(params)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {         
            this.ref.close(true)
          },
          error: errorResponse => {         
          }
        });
    }
  }

  editSubcategory(f: NgForm) { 
    if(f.valid){
      var params : UpdateMenuSubcategory$Params = {} as UpdateMenuSubcategory$Params;
      const editMenuSubcategory: UpdateMenuSubcategoryDto = { name: this.menuSubcategory.name };
      if (this.menuCategory != undefined && this.menuCategory.id) {
        params.menuCategoryId = this.menuCategory.id;     
      }
      if(this.menuSubcategory.id){
        params.menuSubcategoryId = this.menuSubcategory.id;
      }
      params.body = editMenuSubcategory;
        this.menuV2Service.updateMenuSubcategory( params)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.ref.close(true)
          },
          error: errorResponse => {
          }
        });
    }
  }
  close() {
    this.ref.close(null);
  }
}
